import { Card, CardContent, Stack, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router';
import { Forum } from '../database/forum';
import { Rocket, Forum as ForumIcon } from '@mui/icons-material';

interface ForumCardProps {
    forum: Forum;
}

const ForumCard: React.FC<ForumCardProps> = ({ forum }) => {
    const navigate = useNavigate();
    const theme = useTheme();

    const handleClick = () => {
        const encodedName = encodeURIComponent(forum.name);
        const encodedSk = encodeURIComponent(forum.sk);
        navigate(`/ess/${encodedName}-${encodedSk}`);
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -3, scale: 1.01 }}
            whileTap={{ scale: 0.985 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
        >
            <Card
                elevation={3}
                sx={{
                    transition: 'box-shadow 0.25s ease, border-color 0.25s ease',
                    borderLeft: '4px solid transparent',
                    '&:hover': {
                        boxShadow: `0px 8px 28px ${theme.palette.primary.main}50`,
                        borderLeftColor: 'primary.main',
                    },
                }}
            >
                <CardContent>
                    <Stack direction='row' spacing={2} alignItems='flex-start'>
                        <Stack spacing={1} flexGrow={1}>
                            <Stack direction='row' alignItems='center' spacing={1}>
                                <motion.div
                                    whileHover={{ rotate: [0, -15, 15, 0] }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <Rocket sx={{ color: 'primary.main' }} />
                                </motion.div>
                                <Typography variant='h6' fontWeight='bold'>
                                    {forum.name}
                                </Typography>
                            </Stack>
                            <Typography variant='body2'>{forum.description}</Typography>
                        </Stack>
                        <Chip
                            icon={<ForumIcon />}
                            label={`${forum.topicCount} ${
                                forum.topicCount === 1 ? 'topic' : 'topics'
                            }`}
                            size='small'
                            color='primary'
                            variant='outlined'
                        />
                    </Stack>
                </CardContent>
            </Card>
        </motion.div>
    );
};

export default ForumCard;
